export default "__VITE_ASSET__BMQ75iMW__"